export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.department.id.description",//"Código interno",
          label: "wkt.admin.qbuilder.model.department.id.text",//"Código",
          field: "id"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.department.name.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.department.name.text",//"Nombre",
          field: "name"
        }
     ],
}